module.exports = __webpack_public_path__ + "img/icon_radio_button_checked.a5f836a6.svg";